var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.091 1.34961H14.4735C13.1778 1.34961 11.9459 0 10.6501 0H7.35031C6.05459 0 4.8227 1.34961 3.52698 1.34961H1.90918C1.35689 1.34961 0.90918 1.79732 0.90918 2.34961V13.8345C0.90918 14.3867 1.35689 14.8345 1.90918 14.8345H16.091C16.6433 14.8345 17.091 14.3867 17.091 13.8345V2.34961C17.091 1.79732 16.6433 1.34961 16.091 1.34961ZM8.99956 12.1378C11.2338 12.1378 13.045 10.3266 13.045 8.09233C13.045 5.85809 11.2338 4.04688 8.99956 4.04688C6.76531 4.04688 4.9541 5.85809 4.9541 8.09233C4.9541 10.3266 6.76531 12.1378 8.99956 12.1378ZM8.9999 10.7883C10.4894 10.7883 11.6969 9.58078 11.6969 8.09129C11.6969 6.60179 10.4894 5.39432 8.9999 5.39432C7.51041 5.39432 6.30293 6.60179 6.30293 8.09129C6.30293 9.58078 7.51041 10.7883 8.9999 10.7883Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.99a56cbb84290fd00797978412a2f4f1.svg";
export { ForwardRef as ReactComponent };